// src/store/BankAccountStore.js
import { create } from "zustand";
import produce from "immer";
import { persist } from "zustand/middleware";

let store = (set) => ({
  myBankAccounts: [],
  loading: false,
  error: null,

  setMyBankAccounts: (accounts) =>
    set(
      produce((temp) => {
        temp.myBankAccounts = accounts;
      })
    ),

  setLoading: (loading) =>
    set(
      produce((temp) => {
        temp.loading = loading;
      })
    ),

  setError: (error) =>
    set(
      produce((temp) => {
        temp.error = error;
      })
    ),

  reset: () =>
    set(
      produce((temp) => {
        temp.myBankAccounts = [];
        temp.loading = false;
        temp.error = null;
      })
    ),
});

store = persist(store, { name: "bankAccounts" });
export const useBankAccountStore = create(store);